<template>
  <div class="page" v-cloak>
    <!-- 顶部 -->
    <div class="header-top">
      <div class="header-top-left">
        <p>卡劵兑换</p>
        <p class="header-top-left-tips">精选兑换 只在百分百</p>
      </div>
      <div class="header-top-right">
        <div class="img-blocks" @click="dialPhoneNumber()">
          <!-- <van-icon name="orders-o" /> -->
          <img src="../../assets/index/h_icon_2.png" alt="" />
        </div>
      </div>
    </div>

    <div class="center-logo">
      <img src="../../assets/user/logo.png" alt="">
    </div>

    <div class="input-block">

      <h3 class="input-title">百分百兑换卡</h3>

      <div class="input-center-block">
        <div class="password-input">
          <input type="text" v-model="moneyNo" :placeholder="placeholder" @focus="placeholder=''" @blur="placeholder='卡号(卡券上的卡号)'" />
        </div>

        <div class="password-input">
          <form>
            <input :type="inputType" v-model="password" autocomplete :placeholder="placPassw" @focus="placPassw=''" @blur="placPassw='密码(卡券上刮开的密码)'" />
          </form>
          <div :class="['eye', inputType == 'password' ? 'no_eye_icon' : 'eye_icon']" @click="passwordClick"></div>
        </div>

        <div :class="['next-block', password ? 'next' : '']" @click="goExchange">
          下一步
        </div>
      </div>

    </div>
    <p class="foot-tips">
      注：如有问题请联系我们，点击
      <span @click="dialPhoneNumber()">联系我们</span>
    </p>

  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "Index",
  computed: {},
  components: {},
  props: {},
  data() {
    return {
      active: 0,
      h_r_icon: "https://qiniu.zdyxjx.com/minizdyxright.png", //箭头
      iconList: [
        {
          img: "https://qiniu.zdyxjx.com/minizdyxicon_1.png", //  icon
          name: "点击",
          desc: "兑换的类别",
        },
        {
          img: "https://qiniu.zdyxjx.com/minizdyxicon_2.png", // icon
          name: "输入",
          desc: "卡号和密码",
        },
        {
          img: "https://qiniu.zdyxjx.com/minizdyxicon_3.png", // icon
          name: "选择",
          desc: "商品/现金",
        },
        {
          img: "https://qiniu.zdyxjx.com/minizdyxicon_4.png", // icon
          name: "等待",
          desc: "发货/充值",
        },
      ],
      moneyNo: "",
      password: "",
      inputType: "password",
      placeholder: "卡号(实物提货卡券上的卡号)",
      placeholder1: "卡号(等值积分兑换卡上的卡号)",
      placPassw: "密码(实物提货卡券上刮开的密码)",
      placPassw1: "密码(等值积分兑换卡上刮开的密码)",
    };
  },
  watch: {
    moneyNo: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        if (!this.isLogin()) return false;
      },
      deep: true, // 深度监听表单
    },
    password: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        if (!this.isLogin()) return false;
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    // console.log(Math.round(new Date() / 1000))
    // if (1632239400 > Math.round(new Date() / 1000)) {
    //   this.tips()
    // }
  },
  methods: {
    onTabsClick(e) {
      // console.log(e)
    },

    // 是否显示密码
    passwordClick(e) {
      const that = this;
      if (that.inputType == "password") {
        that.inputType = "text";
      } else {
        that.inputType = "password";
      }
    },
    // 下一步
    goExchange() {
      let _this = this;
      if (!this.password) return; //密码为空。。
      if (!this.isLogin()) return false;

      _this.goMall();
    },

    goMall() {
      let _this = this;
      let data = {
        card_code: _this.moneyNo,
        card_pwd: _this.password,
      };
      this.$post("/api/exchange_login", data, data).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          Lockr.set("card_code", _this.moneyNo);
          Lockr.set("card_pwd", _this.password);

          this.$router.push({
            name: "exchange-goods-multiple",
            query: {},
          });

          // console.log(res.data);
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
    // 跳兑换订单
    goExchangeOrder() {
      this.$router.push({
        name: "exchange-order-list",
        query: {},
      });
    },
    // 拨打电话
    dialPhoneNumber() {
      this.MakeCall(); //拨打电话
    },
    setPopShow(e) {
      this.isNoticeShow = e;
    },
  },
};
</script>
<style lang="scss" >
.input-block .van-tabs .van-tabs__wrap .van-tabs__nav {
  background-color: #f9f9f9;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.input-block .van-tabs .van-tabs__wrap .van-tab--active {
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>

<style lang="scss" scoped>
@import "@/styles/index.scss";

.page {
  height: 100%;
  background-color: #f9f9f9;
}
.header-top {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  // background-color: #fff;
  &-left {
    font-size: $fS24;
    color: $h1color;
    &-tips {
      line-height: 21px;
      font-size: $fS12;
      color: $h3color;
    }
  }
  &-right {
    display: flex;
    justify-content: center;
    align-items: center;

    .img-blocks {
      width: 15px;
      height: 20px;
      font-size: 20px;
    }
    .img-blocks img {
      width: 100%;
      height: 100%;
    }
  }
}
// 顶部搜索栏
.center-logo {
  margin-top: 20px;
  width: 100%;
  height: 96px;
  img {
    display: block;
    width: 96px;
    height: 100%;
    margin: 0 auto;
  }
}

.input-block {
  // height: 635px;
  background-color: #fff;
  margin: 30px 10px 0;

  border-radius: 6px;

  .input-title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 30px;
    color: #ff5000;
    letter-spacing: 1px;
    position: relative;
  }
  .input-title::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 2px;
    left: 47%;
    bottom: -5px;
    /* background-color: red; */
    background: #ff5000;
    z-index: 1;
    border-radius: 11px 0 0 0;
    opacity: 0.8;
  }
  .input-center-block {
    padding: 0 15px 15px;
    .password-input {
      // margin: 100px 0;
      width: 100%;
      box-sizing: border-box;
      height: 73px;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: space-between;
      form {
        width: 90%;
        height: 100%;
      }
      input {
        width: 100%;
        height: 100%;
        text-align: center;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
      }
      .eye {
        // background-color: #eee;
        width: 16px;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 20%;
        background-position: 0 25px;
      }

      .eye_icon {
        background-image: url("https://qiniu.zdyxjx.com/minizdyxeye.png");
      }
      .no_eye_icon {
        background-image: url("https://qiniu.zdyxjx.com/minizdyxno-eye.png");
      }
    }

    .next-block {
      margin: 15px auto;
      width: 293px;
      height: 40px;
      background: #eeeeee;
      border-radius: 20px;
      background-color: #eee;

      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 20px;
      color: #cccccc;
      letter-spacing: 1px;
    }
    .next {
      background-color: #ff5000;
      color: #fff;
    }
  }
}

// 底部提示
.foot-tips {
  padding-left: 10px;
  margin-top: 10px;
  text-align: left;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 20px;
  color: #78849e;
  letter-spacing: 1px;
  span {
    color: #ff5000;
  }
}
</style>
